export class InitOrderModel {
  public orderTypeId!: string;
  public startDate!: Date;
  public contactId?: string;
}
